module.exports = __webpack_public_path__ + "img/IT0000101245279.2068ea29.png";